import {fadeIn, fadeOut} from "./utilities/fade";

export function showMobileMenu(menu, overlay, toggle) {
    fadeIn(overlay, 200, "linear", function () {
        menu.classList.add("open");
        toggle.classList.add("is-active");
        document.body.classList.add("mobile-menu-is-open");
    });
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("open");
    toggle.classList.remove("is-active");
    fadeOut(overlay,function (){
        document.body.classList.remove("mobile-menu-is-open");
    });
}